import React, { useState } from 'react';
import {
    Box,
    Button,
    TextField,
    Typography,
    Paper,
} from '@mui/material';
import { postData } from '../utils/helper';
import { ToastContainer, toast, Bounce } from 'react-toastify';
import { PropagateLoader } from "react-spinners";
import { useNavigate } from 'react-router-dom';

const CSSProperties = {
    display: "block",
    margin: "0 auto",
    borderColor: "red",
};

const ChangePassword = () => {
    const [passwordData, setPasswordData] = useState({
        current_password: '',
        new_password: '',
        confirmPassword: ''
    });
    const navigate = useNavigate();
    let [loading, setLoading] = useState(false);
    const textFieldStyle = {
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                borderColor: '#00BFFF',
            },
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: '#00BFFF',
        },
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPasswordData(prev => ({
            ...prev,
            [name]: value
        }));

    };

    const handleSubmit = async () => {
        if (passwordData.current_password === '' || passwordData.new_password === '' || passwordData.confirmPassword === '') {
            toast.error('Please fill all fields', {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });
        } else if (passwordData.new_password !== passwordData.confirmPassword) {
            toast.error('New password and confirm password do not match', {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });
        } else if (passwordData.new_password.length < 6) {
            toast.error('Password must be greater than six characters', {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });
        } else {
            try {
                setLoading(true);
                const response = await postData('change-password', passwordData);
                if (response.status === 401) {
                    navigate('/', { state: { message: "Session Expired" } });
                    setLoading(false);
                    return;
                }
                setLoading(false);
                if (response?.status === undefined) {
                    sessionStorage.removeItem('token');
                    sessionStorage.setItem('token', response?.data?.token);
                    toast.success("Password change successfully", {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        transition: Bounce,
                    });
                    setPasswordData({
                        current_password: '',
                        new_password: '',
                        confirmPassword: ''
                    });
                } else {
                    toast.error(response?.response?.data?.error, {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        transition: Bounce,
                    });
                }
            } catch (error) {
                setLoading(false);
                toast.error(error, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    transition: Bounce,
                });
            }
        }
    };

    return (
        <>
            {loading && (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    width: '100vw',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.8)', // Optional: semi-transparent white background
                    zIndex: 9999, // Ensure it's above other elements
                }}>
                    <PropagateLoader
                        color="#00BFFF"
                        loading={loading}
                        cssOverride={CSSProperties}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                </div>
            )}

            <Paper elevation={3} sx={{ p: 3, maxWidth: 500, margin: 'auto' }}>
                <ToastContainer />
                <Typography variant="h5" component="h2" gutterBottom sx={{ textAlign: 'center' }}>
                    Change Password
                </Typography>
                <Box
                    sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
                >
                    <TextField
                        fullWidth
                        label="Current Password"
                        type="password"
                        name="current_password"
                        value={passwordData.current_password}
                        onChange={handleChange}
                        required
                        variant="outlined"
                        sx={textFieldStyle}
                    />
                    <TextField
                        fullWidth
                        label="New Password"
                        name="new_password"
                        type="password"
                        value={passwordData.new_password}
                        onChange={handleChange}
                        required
                        variant="outlined"
                        sx={textFieldStyle}
                    />
                    <TextField
                        fullWidth
                        label="Confirm Password"
                        name="confirmPassword"
                        type="password"
                        value={passwordData.confirmPassword}
                        onChange={handleChange}
                        required
                        variant="outlined"
                        sx={textFieldStyle}
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        onClick={handleSubmit}
                        sx={{
                            backgroundColor: '#00BFFF',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#009ACD', // darker shade for hover
                            }
                        }}
                    >
                        Change Password
                    </Button>
                </Box>
            </Paper>
        </>
    )
}

export default ChangePassword;